var render, staticRenderFns
import script from "./SmartTable.vue?vue&type=script&lang=js"
export * from "./SmartTable.vue?vue&type=script&lang=js"
import style0 from "./SmartTable.vue?vue&type=style&index=0&id=0fdbe828&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdbe828",
  null
  
)

export default component.exports